import type { FC } from 'react';

import { Archive } from './Icons/Archive';
import { Arrow } from './Icons/Arrow';
import { Bathroom } from './Icons/Bathroom';
import { Bedroom } from './Icons/Bedroom';
import { Checkmark } from './Icons/Checkmark';
import { Close } from './Icons/Close';
import { Delete } from './Icons/Delete';
import { Edit } from './Icons/Edit';
import { Email } from './Icons/Email';
import { Export } from './Icons/Export';
import { Facebook } from './Icons/Facebook';
import { HidePassword } from './Icons/HidePassword';
import { Information } from './Icons/Information';
import { Linkedin } from './Icons/Linkedin';
import { LogoDark } from './Icons/LogoDark';
import { LogoLight } from './Icons/LogoLight';
import { MapPin } from './Icons/MapPin';
import { MarkAs } from './Icons/MarkAs';
import { Menu } from './Icons/Menu';
import { MenuDots } from './Icons/MenuDots';
import { Minus } from './Icons/Minus';
import { Owner } from './Icons/Owner';
import { Phone } from './Icons/Phone';
import { Pin } from './Icons/Pin';
import { Plus } from './Icons/Plus';
import { PlusCircle } from './Icons/PlusCircle';
import { Profile } from './Icons/Profile';
import { Reset } from './Icons/Reset';
import { Search } from './Icons/Search';
import { ShowPassword } from './Icons/ShowPassword';
import { SignOut } from './Icons/SignOut';
import { Sort } from './Icons/Sort';
import { Sqft } from './Icons/Sqft';
import { Svg } from './styled';

export enum IconName {
    'EXPORT',
    'SEARCH',
    'SORT',
    'CHECKMARK',
    'FACEBOOK',
    'LINKEDIN',
    'LOGO_LIGHT',
    'LOGO_DARK',
    'ARROW',
    'PLUS',
    'PLUS_CIRCLE',
    'EDIT',
    'SHOW_PASSWORD',
    'HIDE_PASSWORD',
    'CLOSE',
    'PHONE',
    'EMAIL',
    'PIN',
    'MAP_PIN',
    'MENU',
    'MENU_DOTS',
    'MINUS',
    'INFORMATION',
    'MARK_AS',
    'SQFT',
    'BEDROOM',
    'BATHROOM',
    'RESET',
    'ARCHIVE',
    'DELETE',
    'OWNER',
    'PROFILE',
    'SIGN_OUT',
}

export const MappedIcon = {
    [IconName.EXPORT]: Export,
    [IconName.SEARCH]: Search,
    [IconName.SORT]: Sort,
    [IconName.CHECKMARK]: Checkmark,
    [IconName.FACEBOOK]: Facebook,
    [IconName.LINKEDIN]: Linkedin,
    [IconName.LOGO_LIGHT]: LogoLight,
    [IconName.LOGO_DARK]: LogoDark,
    [IconName.ARROW]: Arrow,
    [IconName.PLUS]: Plus,
    [IconName.PLUS_CIRCLE]: PlusCircle,
    [IconName.EDIT]: Edit,
    [IconName.SHOW_PASSWORD]: ShowPassword,
    [IconName.HIDE_PASSWORD]: HidePassword,
    [IconName.CLOSE]: Close,
    [IconName.PHONE]: Phone,
    [IconName.EMAIL]: Email,
    [IconName.PIN]: Pin,
    [IconName.MAP_PIN]: MapPin,
    [IconName.MENU]: Menu,
    [IconName.MENU_DOTS]: MenuDots,
    [IconName.MINUS]: Minus,
    [IconName.INFORMATION]: Information,
    [IconName.MARK_AS]: MarkAs,
    [IconName.SQFT]: Sqft,
    [IconName.BEDROOM]: Bedroom,
    [IconName.BATHROOM]: Bathroom,
    [IconName.RESET]: Reset,
    [IconName.ARCHIVE]: Archive,
    [IconName.DELETE]: Delete,
    [IconName.OWNER]: Owner,
    [IconName.PROFILE]: Profile,
    [IconName.SIGN_OUT]: SignOut,
};

export interface IIcon {
    iconName: IconName;
    className?: string;
}

export const Icon: FC<IIcon> = ({ iconName, className }) => {
    const IconComponent = MappedIcon[iconName];
    return (
        <Svg
            className={className}
            viewBox={IconComponent.viewBox || '0 0 21 21'}
        >
            <IconComponent data-test="Icon-Selected" />
        </Svg>
    );
};

Icon.defaultProps = {
    className: '',
};
